import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

const ReportsSidebar = () => {
    const navigate = useNavigate();
    const pathname = useLocation().pathname;

    const reportNavItems = [
        {
            name: 'User Sign Up',
            path: '/reports/user-sign-up',
        },
        {
            name: 'Active User',
            path: '/reports/active-user',
        },
        {
            name: 'Active User Demographics',
            path: '/reports/active-user-demographics',
        },
        {
            name: 'User Visits',
            path: '/reports/user-visits',
        },
        {
            name: 'Page Views',
            path: '/reports/page-views',
        },
        {
            name: 'User Scores',
            path: '/reports/user-scores',
        },
        {
            name: 'User Jobs',
            path: '/reports/user-jobs',
        },
        {
            name: 'Certificate Awards',
            path: '/reports/certificate-awards',
        },
        {
            name: 'Interviews Completed',
            path: '/reports/interviews-completed',
        },
    ]

    const onGoToReport = (path: string) => {
        navigate(path);
    }

    const getActiveReport = (path: string) => {
        return pathname === path ? 'immersion_admin__reports_sidebar__tab__active' : '';
    }
    return (
        <div className="immersion_admin__reports_sidebar">
            <h5 className="immersion_admin__reports_sidebar__title">Reports</h5>

            {reportNavItems.map((item) => (
                <button
                    key={item.path}
                    onClick={() => onGoToReport(item.path)}
                    className={`immersion_admin__reports_sidebar__tab ${getActiveReport(item.path)}`}
                >
                    {item.name}
                </button>
            ))}

        </div>
    )
}

export default ReportsSidebar